import { localStorages, sessionStorages } from './localStorages'
import vue from '../main'
import config from "../config/axiosConf.js";

// const client_id = localStorages.getItem("client_id") ? localStorages.getItem("client_id"): "GFxTlkHvM5lBmjUlLfzB"

// const logoutUrl = "http://jaccount.sjtu.edu.cn/oauth2/logout?client_id=" + client_id
//               + "&post_logout_redirect_uri=" + config.redirect_uri

export const logout = function() {
  let logoutUrl = getLogoutUrl()
  clearStorage()
  // window.location.href = `${window.location.origin}/login`;
  // JAccount统一认证的重定向
  window.location.href = logoutUrl
  // vue.$router.push("/login"); // vue router的跳转很丝滑
}

export const logoutDelay = function(delay = 1000) {
  let logoutUrl = getLogoutUrl()
  clearStorage()
  setTimeout(() => {
    // window.location.href = `${window.location.origin}/login`;
    window.location.href = logoutUrl
    // vue.$router.push("/login");
  }, delay);
}
export const getLogoutUrl = function() {
  let client_id = localStorages.getItem("client_id")
  if (!client_id || client_id === "") {
    client_id =  "GFxTlkHvM5lBmjUlLfzB"
  }
  let redirect_uri = config.redirect_uri + "/?code=logout"
  return "http://jaccount.sjtu.edu.cn/oauth2/logout?client_id=" + client_id
              + "&post_logout_redirect_uri=" + redirect_uri
}

export const clearStorage = function() {
  // params stored for user info
  localStorages.removeItem("id_token");
  localStorages.removeItem("refresh_token");
  localStorages.removeItem("peopleId");
  localStorages.removeItem("userId");
  localStorages.removeItem("tenantId");
  localStorages.removeItem("tenantSign");
  localStorages.removeItem("tenantInfo");
  sessionStorages.removeItem("userId");
  
  localStorages.removeItem("client_id")
  localStorages.removeItem("client_secret")

  // params stored for websocket
  localStorages.setItem("connKey", '')
  localStorages.setItem("wsisClose", true)
  console.log(vue.$store.state.ws.length)
  console.log(vue.$store.state.interval.length)
  vue.$store.state.ws.forEach(element => {
    element.close()
  });
  vue.$store.state.interval.forEach(element => {
    clearInterval(element)
  })
  vue.$store.state.interval = []
  vue.$store.state.ws = []
}



// WEBPACK FOOTER //
// ./src/utils/logout.js